import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import useService from "../../hooks/useService"
import { updatePurityVerificationCharges } from "../../services/Customer"
import Modal from "."
import { cancelTransaction } from "../../services/Transactions"
import { TOption } from "../../Models/common"
import { CANCEL_REASONS, PURITY_VERIFICATION_CHARGE_OPTIONS, TRANSACTION_STATUS, TRANSACTION_TYPES } from "../../utils/constant"
import { CheckBox } from "@mui/icons-material"

type TCancelTransactionModalProps = {
    open: boolean
    onClose: () => any
    onSuccess: (transactionId: string) => any
}
const CancelTransactionModal = (props: TCancelTransactionModalProps) => {

    const { onClose, open, onSuccess } = props

    return <Modal
        open={open}
        onClose={onClose}
        title="Cancel Transaction"
    >
        <CancelTransaction onSuccess={onSuccess} />
    </Modal>
}

const CancelTransaction = ({ onSuccess }: { onSuccess: (transactionId: string) => any }) => {

    // const purityTestingChargesRef = useRef<HTMLInputElement>(null)
    const [purityTestingChargesInput, setPurityTestingChargesInput] = useState()
    const { store, execute } = useService()
    const { notificationStore, customerStore, transactionsStore } = store
    const { notify } = notificationStore
    const { customerConfig } = customerStore
    const { purityVerificationCharges } = customerConfig
    const { transactionInfo } = transactionsStore
    const [options, setOptions] = useState<TOption[]>(PURITY_VERIFICATION_CHARGE_OPTIONS)
    const conditionsForApproval = [transactionInfo.status != TRANSACTION_STATUS.INBOUND_INITIATED && transactionInfo.transactionType === TRANSACTION_TYPES.PURITY_TESTING, transactionInfo.status === TRANSACTION_STATUS.COMPLETED && transactionInfo.transactionType === TRANSACTION_TYPES.MINTED_SALES]
    const hidePurityConversionOption = () => transactionInfo.status === TRANSACTION_STATUS.INBOUND_INITIATED || [TRANSACTION_TYPES.PURITY_TESTING, TRANSACTION_TYPES.MINTED_SALES].includes(transactionInfo.transactionType)
    const [convertToPurityTesting, setConvertToPurityTesting] = useState(false)
    const [selectedOption, setSelectedOption] = useState("");


    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const purityTestingCharges = purityTestingChargesInput

        if (convertToPurityTesting && !purityTestingCharges) return notify('Purity Verification Charges cannot be empty', 'error')

        if (convertToPurityTesting && customerConfig.purityVerificationCharges != purityTestingCharges) {

            const customerUpdated = await execute(() => updatePurityVerificationCharges({
                customerRefNo: customerConfig.customerRefNo!,
                purityVerificationCharges: +purityTestingCharges! as any,
            }))

            if (customerUpdated.error != null) return
        }

        const { error, data } = await execute(() => cancelTransaction({
            globalTransactionNumber: transactionInfo.globalTransactionNumber!,
            transactionType: transactionInfo.transactionType,
            isApprovalRequired: (!convertToPurityTesting && !hidePurityConversionOption()) || conditionsForApproval.includes(true),
            cancelReason : selectedOption
        }))
        if (error === null) onSuccess(data?.globalTransactionNumber!)
    }

    useEffect(() => {
        if (customerConfig.purityVerificationCharges && convertToPurityTesting) {
            if (!options.filter(option => option.value == customerConfig.purityVerificationCharges).length) {
                setOptions(prev => ([...prev, { label: String(purityVerificationCharges), value: purityVerificationCharges }]))
            }
            setPurityTestingChargesInput(customerConfig.purityVerificationCharges as any)
        }
    }, [convertToPurityTesting])

    const PurityTestingChargesInput = () => {
        return <div>
            <FormControl required fullWidth size='small'>
                <InputLabel id={`purity_charge_label`}>Purity Verification Charges</InputLabel>
                <Select
                    labelId={`purity_charge_label`}
                    label='Purity Verification Charges'
                    // inputRef={purityTestingChargesRef}
                    value={purityTestingChargesInput}
                    onChange={(e) => setPurityTestingChargesInput(e.target.value as any)}
                >
                    {options?.map((option, index) => {
                        return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                    })}
                </Select>
            </FormControl>
        </div>
    }

    const ConvertToPurityTestingCheckbox = () => {
        return <div style={{ width: '100%' }}>
            <FormControlLabel
                sx={{ color: "#7f7d76" }}
                control={
                    <Checkbox
                        size='small'
                        onChange={(e, checked) => setConvertToPurityTesting(checked)}
                        checked={convertToPurityTesting}
                    />
                }
                label='Convert to Purity Testing?'
            />
        </div>
    }

    return <form onSubmit={submitHandler} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {
            !hidePurityConversionOption()
                ?
                <>
                    {
                        convertToPurityTesting
                            ?
                            <PurityTestingChargesInput />
                            :
                            <></>
                    }
                    <ConvertToPurityTestingCheckbox />
                </>
                :
                <></>
        }
        <Typography variant="body2" color='red'>
            {
                convertToPurityTesting
                    ?
                    'By clicking CONTINUE, you will convert the current transaction into Purity Testing.'
                    :
                    conditionsForApproval.includes(true) || !hidePurityConversionOption()
                        ?
                        'By clicking CONTINUE, you will send an approval request for the cancellation of the current transaction.'
                        :
                        'By clicking CONTINUE, you will cancel the current transaction.'
            }
        </Typography>
        <Autocomplete
        value={selectedOption}
        onChange={(event, newValue) => setSelectedOption(newValue as any)}
        options={CANCEL_REASONS}
        renderInput={(params) => <TextField {...params} label="Select Cancel Reason" />}
        style={{ width: '100%' }} // Adjust the width of the dropdown
      />
        <div style={{ width: '100%', textAlign: 'right' }}>
            <div style={{ width: '100%', textAlign: 'right' }}>
                <Button type="submit" variant="contained" style={{ marginLeft: 'auto' }} disabled={!selectedOption}  >Continue</Button>
            </div>
        </div>
    </form>
}

export default CancelTransactionModal